module.exports = __webpack_public_path__ + "static/media/obc-logo-hybrid.0f106b13.svg";